// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  pureSpectrum: {
    url: 'https://qa7-api.spectrumsurveys.com',
    activityUrl: 'https://activitystaging.spectrumsurveys.com',
    decipherUrl: 'https://decipherstaging.spectrumsurveys.com',
    ipsosUrl: 'https://ipsosstaging.spectrumsurveys.com',
    nightcrawlerUrl:
      'https://nightcrawlerapistaging.spectrumsurveys.com/api/v1',
    buyerExternalIntegrationUrl:
      'https://partnersapistaging.spectrumsurveys.com',
    reconcilationUrl: 'https://kz613jq876.execute-api.us-east-1.amazonaws.com',
    feasibilityUrl: 'https://gateway-staging.spectrumsurveys.com',
    gatewayUrl: 'https://gateway-staging.spectrumsurveys.com',
    priceRecommendUrl: 'https://black-box-staging.spectrumsurveys.com',
    rmfUrl: 'https://adjustments-staging.spectrumsurveys.com',
    // Used for decipher buyer settings iframe
    legacyPlatformUrl: 'https://platform-ui.qa7.purespectrum.com',
    surveyStatiscticsServiceUrl:
      'https://statistics-staging.spectrumsurveys.com',
    reportServiceUrl: 'https://reportsservicestaging.spectrumsurveys.com',
    qaToolsUrl: 'https://qa_tools.spectrumsurveys.com',
    storageSalt:
      '25695b67446c4de57b31a59a33112e8bbe1bcd3345c5f5a15e4552d776e9578a',
  },
  BUCKET_URL: 'https://ps-stage-zip-reports.s3.amazonaws.com',
  churnzeroUrl: 'https://analytics.churnzero.net',
  CATPTCHA_SITE_KEY: '6LdrE8QUAAAAAFo5nDaqxOflsQueY74M4fxIcf1u',
  QUICKBOOK_VAT_REALMS: [4620816365168553000], // PureSpectrum Sandbox
  BUYER_TEST_LINK_SUPPLIER_ID: 26,
  START_SURVEY_URL: '/startsurvey',
  PS_CMP_ID: 4, // PS Company Id for setup Service Operator access level
  ENABLE_HOTJAR_EVENT: false, // Flag to indicate if Hotjar event caprturing is enabled or not
  FUSION_CMP_ID: 217,
  FUSION_API_URL: 'https://routerapistaging.spectrumsurveys.com',
  ZAPPI_STORE_BUYER_IDS: [3797, 3775],
  PUREPRICE_RATECARD_NOTIFICATION_SLACK_CHANNEL: 'jarvis-notification-staging',
  appcuesUrl: '//fast.appcues.com/220859.js',
  intercomAppId: 'edws7hvf',
  fullstoryOrgId: 'o-24CGB4-na1',
  signUpUrl: 'https://www.purespectrum.com/schedule-a-demo',
  authUrl: 'https://auth-staging.purespectrum.com',
  ENV: 'qa',
};
